/**
 * @generated SignedSource<<ab0ae2abadc9a907a8d8c1a48ce2452c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MarkupType = "FIXED" | "STANDARD";
export type PackageStatus = "DRAFT" | "EXPIRED" | "PUBLISHED" | "WAITING";
export type TransportType = "BUS" | "PLANE" | "SHIP";
export type UpdatePackageInput = {
  alreadyPurchased?: number | null;
  autoHotelPriceUpdate?: boolean | null;
  categories?: ReadonlyArray<SetEntityInput> | null;
  cateringOptions?: ReadonlyArray<EntityWithPositionInput> | null;
  city?: SetEntityInput | null;
  defaultArrivalAirport?: SetEntityInput | null;
  defaultDepartureAirport?: SetEntityInput | null;
  descriptionText?: string | null;
  descriptionTitle?: string | null;
  documents?: ReadonlyArray<SetEntityInput> | null;
  externalFlights?: boolean | null;
  hotel?: SetEntityInput | null;
  hotelComment?: string | null;
  individualAdvance?: number | null;
  labels?: ReadonlyArray<SetEntityInput> | null;
  markupType?: MarkupType | null;
  markupValueAdult?: number | null;
  markupValueChild?: number | null;
  name?: string | null;
  notesText?: string | null;
  notesTitle?: string | null;
  organiser?: string | null;
  remainingPaymentDeadlineDays?: number | null;
  rooms?: ReadonlyArray<EntityWithPositionInput> | null;
  services?: ReadonlyArray<UpdatePackageServices> | null;
  status?: PackageStatus | null;
  subtitle?: string | null;
  terms?: ReadonlyArray<UpdatePackageTerms> | null;
  transferPrice?: number | null;
  transportName?: string | null;
  transportType?: TransportType | null;
  tripEnd?: string | null;
  tripStart?: string | null;
  validBeforeTripStartDays?: number | null;
  whatToSee?: SetEntityInput | null;
};
export type SetEntityInput = {
  id: string;
};
export type UpdatePackageTerms = {
  id: string;
  included: boolean;
};
export type UpdatePackageServices = {
  id: string;
  position: number;
};
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type PackageEditTransportMutation$variables = {
  first: number;
  id: string;
  input: UpdatePackageInput;
};
export type PackageEditTransportMutation$data = {
  readonly updatePackage: {
    readonly " $fragmentSpreads": FragmentRefs<"PackageEditTabs_package" | "PackageSidebar_package">;
  };
};
export type PackageEditTransportMutation = {
  response: PackageEditTransportMutation$data;
  variables: PackageEditTransportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v9 = [
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "icon",
    "storageKey": null
  }
],
v10 = [
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceLive",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "departDatetime",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "departAirportCode",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "arrivalAirportCode",
  "storageKey": null
},
v17 = [
  (v5/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "arrivalDatetime",
    "storageKey": null
  },
  (v16/*: any*/)
],
v18 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "S120X120"
    }
  ],
  "kind": "ScalarField",
  "name": "externalUrl",
  "storageKey": "externalUrl(size:\"S120X120\")"
},
v21 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "w262"
    }
  ],
  "kind": "ScalarField",
  "name": "src",
  "storageKey": "src(size:\"w262\")"
},
v22 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nameString",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "capacity",
    "storageKey": null
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v24 = [
  (v23/*: any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isFlightSegmentType"
  },
  (v5/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PackageEditTransportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Package",
        "kind": "LinkedField",
        "name": "updatePackage",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageEditTabs_package"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageSidebar_package"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PackageEditTransportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Package",
        "kind": "LinkedField",
        "name": "updatePackage",
        "plural": false,
        "selections": [
          {
            "alias": "allDates",
            "args": (v2/*: any*/),
            "concreteType": "PackageDateConnection",
            "kind": "LinkedField",
            "name": "tripDates",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": "tripDates(first:2147483647)"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "MediaConnection",
            "kind": "LinkedField",
            "name": "media",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": "media(first:2147483647)"
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subtitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markupType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markupValueAdult",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markupValueChild",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validBeforeTripStartDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remainingPaymentDeadlineDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "individualAdvance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alreadyPurchased",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "descriptionTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "descriptionText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notesTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notesText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organiser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "City",
            "kind": "LinkedField",
            "name": "city",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Label",
            "kind": "LinkedField",
            "name": "labels",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WhatToSee",
            "kind": "LinkedField",
            "name": "whatToSee",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Term",
            "kind": "LinkedField",
            "name": "included",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Term",
            "kind": "LinkedField",
            "name": "excluded",
            "plural": true,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TravelDocument",
            "kind": "LinkedField",
            "name": "documents",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transportType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalFlights",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transportName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transferPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Service",
            "kind": "LinkedField",
            "name": "services",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Airport",
            "kind": "LinkedField",
            "name": "defaultDepartureAirport",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Airport",
            "kind": "LinkedField",
            "name": "defaultArrivalAirport",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": "dates",
            "args": (v2/*: any*/),
            "concreteType": "PackageDateConnection",
            "kind": "LinkedField",
            "name": "tripDates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PackageDateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PackageDate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Flight",
                        "kind": "LinkedField",
                        "name": "flight",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forwardFlightNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "returnFlightNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forwardChangeDuration",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "returnChangeDuration",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlightSegment",
                            "kind": "LinkedField",
                            "name": "forwardSegments",
                            "plural": true,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlightSegment",
                            "kind": "LinkedField",
                            "name": "returnSegments",
                            "plural": true,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": "tripDates(first:2147483647)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Hotel",
            "kind": "LinkedField",
            "name": "hotel",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destination",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Media",
                "kind": "LinkedField",
                "name": "mainMedia",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Text",
                "kind": "LinkedField",
                "name": "descriptionText",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TextBlock",
                    "kind": "LinkedField",
                    "name": "activeBlock",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "data",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "RoomConnection",
                "kind": "LinkedField",
                "name": "rooms",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoomEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Room",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "rooms(first:2147483647)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CateringOption",
            "kind": "LinkedField",
            "name": "cateringOptions",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Room",
            "kind": "LinkedField",
            "name": "rooms",
            "plural": true,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupedRate",
            "kind": "LinkedField",
            "name": "groupedRates",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PackageDate",
                "kind": "LinkedField",
                "name": "date",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Flight",
                    "kind": "LinkedField",
                    "name": "flight",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateByCatering",
                "kind": "LinkedField",
                "name": "ratesByCatering",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CateringOption",
                    "kind": "LinkedField",
                    "name": "cateringOption",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "etgKey",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RateByRoom",
                    "kind": "LinkedField",
                    "name": "ratesByRoom",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Room",
                        "kind": "LinkedField",
                        "name": "room",
                        "plural": false,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoomRate",
                        "kind": "LinkedField",
                        "name": "roomRate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roomPriceAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tripPriceAdult",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "priceNett",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roomPriceChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tripPriceChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baseCostAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baseCostChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPercentMarkup",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupPercentAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupPercentChild",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupAmountAdult",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "markupAmountChild",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              }
            ],
            "concreteType": "PackageDateConnection",
            "kind": "LinkedField",
            "name": "tripDates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PackageDateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PackageDate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "validTo",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "duration",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accommodationPrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Flight",
                        "kind": "LinkedField",
                        "name": "flight",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUpdating",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlightPrice",
                            "kind": "LinkedField",
                            "name": "lastUpdate",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "forwardSegments",
                                "plural": true,
                                "selections": (v24/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "returnSegments",
                                "plural": true,
                                "selections": (v24/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "FlightType",
                            "abstractKey": "__isFlightType"
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deletable",
                            "storageKey": null
                          }
                        ],
                        "type": "Entity",
                        "abstractKey": "__isEntity"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "link",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoHotelPriceUpdate",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "MediaConnection",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Media",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v23/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "media(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "MediaEditor_mediable_media",
                "kind": "LinkedHandle",
                "name": "media"
              }
            ],
            "type": "Mediable",
            "abstractKey": "__isMediable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Seo",
                "kind": "LinkedField",
                "name": "seo",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metaTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metaDescription",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Seoable",
            "abstractKey": "__isSeoable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LogEntry",
                "kind": "LinkedField",
                "name": "logs",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "context",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "severity",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Logable",
            "abstractKey": "__isLogable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ed6c7aa473ae73d74a5b7571d2b53c5",
    "id": null,
    "metadata": {},
    "name": "PackageEditTransportMutation",
    "operationKind": "mutation",
    "text": "mutation PackageEditTransportMutation(\n  $first: Int!\n  $id: ID!\n  $input: UpdatePackageInput!\n) {\n  updatePackage(id: $id, input: $input) {\n    ...PackageEditTabs_package\n    ...PackageSidebar_package\n    id\n  }\n}\n\nfragment AssignHotelToPackageDialog_package on Package {\n  id\n}\n\nfragment CateringOptionName_cateringOption on CateringOption {\n  name\n  etgKey\n}\n\nfragment CopyFlightButton_packageDate on PackageDate {\n  id\n  flight {\n    forwardFlightNumber\n    returnFlightNumber\n    id\n  }\n}\n\nfragment EntityHistoryEntryIcon_entry on LogEntry {\n  severity\n}\n\nfragment EntityHistoryEntry_entry on LogEntry {\n  name\n  createdAt\n  description\n  user {\n    name\n    id\n  }\n  ...EntityHistoryJsonContext_entry\n  ...EntityHistoryEntryIcon_entry\n}\n\nfragment EntityHistoryJsonContext_entry on LogEntry {\n  context\n}\n\nfragment EntityHistory_entity on Logable {\n  __isLogable: __typename\n  logs {\n    id\n    ...EntityHistoryEntry_entry\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment FlightSearchForm_defaultArrivalAirport on Airport {\n  id\n  name\n  code\n}\n\nfragment FlightSearchForm_defaultDepartureAirport on Airport {\n  id\n  name\n  code\n}\n\nfragment FlightSegments_segments on FlightSegment {\n  id\n  departDatetime\n  departAirportCode\n  arrivalDatetime\n  arrivalAirportCode\n}\n\nfragment FlightShortDetailsSegments_segments on FlightSegmentType {\n  __isFlightSegmentType: __typename\n  id\n  departDatetime\n  departAirportCode\n  arrivalAirportCode\n}\n\nfragment FlightShortDetails_flight on FlightType {\n  __isFlightType: __typename\n  id\n  forwardSegments {\n    __typename\n    ...FlightShortDetailsSegments_segments\n    id\n  }\n  returnSegments {\n    __typename\n    ...FlightShortDetailsSegments_segments\n    id\n  }\n}\n\nfragment MediaEditorPreviews_media on MediaConnection {\n  edges {\n    node {\n      id\n      ...MediaEditorThumb_media\n    }\n  }\n}\n\nfragment MediaEditorSort_media on MediaConnection {\n  edges {\n    node {\n      id\n    }\n  }\n}\n\nfragment MediaEditorThumb_media on Media {\n  id\n  ...MediaThumb_media\n}\n\nfragment MediaEditor_mediable on Mediable {\n  __isMediable: __typename\n  id\n  media(first: 2147483647) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...MediaEditorPreviews_media\n    ...MediaEditorSort_media\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MediaThumb_media on Media {\n  type\n  externalUrl(size: S120X120)\n  src(size: w262)\n}\n\nfragment PackageAutoHotelPriceUpdateSwitch_package on Package {\n  id\n  autoHotelPriceUpdate\n}\n\nfragment PackageDateAddFlightDialog_package on Package {\n  defaultDepartureAirport {\n    ...FlightSearchForm_defaultDepartureAirport\n    id\n  }\n  defaultArrivalAirport {\n    ...FlightSearchForm_defaultArrivalAirport\n    id\n  }\n}\n\nfragment PackageDateAddFlightDialog_packageDate on PackageDate {\n  id\n  start\n  end\n}\n\nfragment PackageDateRowFlightDetails_package on Package {\n  transportType\n  ...PackageDateAddFlightDialog_package\n}\n\nfragment PackageDateRowFlightDetails_packageDate on PackageDate {\n  flight {\n    id\n    priceLive\n    lastUpdate {\n      status\n      id\n    }\n    ...FlightShortDetails_flight\n  }\n  ...PackageDateAddFlightDialog_packageDate\n}\n\nfragment PackageDateRowFlightPrice_flight on Flight {\n  priceLive\n  isUpdating\n}\n\nfragment PackageDateRowFlight_package on Package {\n  transportType\n  externalFlights\n  ...PackageDateRowFlightDetails_package\n}\n\nfragment PackageDateRowFlight_packageDate on PackageDate {\n  flight {\n    ...PackageDateRowFlightPrice_flight\n    id\n  }\n  ...PackageDateRowFlightDetails_packageDate\n}\n\nfragment PackageDateRow_package on Package {\n  status\n  ...PackageDateRowFlight_package\n}\n\nfragment PackageDateRow_packageDate on PackageDate {\n  id\n  start\n  end\n  validTo\n  duration\n  accommodationPrice\n  ...EntityTableRow_entity\n  ...PackageDateRowFlight_packageDate\n  ...PackageDateStatus_packageDate\n}\n\nfragment PackageDateStatus_packageDate on PackageDate {\n  status\n}\n\nfragment PackageEditAccommodation_package on Package {\n  hotel {\n    id\n  }\n  ...PackageEditAccomodationHotel_package\n  ...PackageEditAccomodationPrices_package\n  ...AssignHotelToPackageDialog_package\n}\n\nfragment PackageEditAccomodationHotel_package on Package {\n  id\n  hotel {\n    id\n    name\n    destination\n    mainMedia {\n      ...MediaThumb_media\n      id\n    }\n    descriptionText {\n      activeBlock {\n        data\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment PackageEditAccomodationPrices_package on Package {\n  cateringOptions {\n    id\n  }\n  rooms {\n    id\n  }\n  ...RoomRatesTable_package\n  ...RoomRatesEditorInit_package\n  ...RoomRatesToolbar_package\n}\n\nfragment PackageEditDatesAdd_package on Package {\n  id\n}\n\nfragment PackageEditDatesList_package_3ASum4 on Package {\n  id\n  transportType\n  externalFlights\n  tripDates(first: $first) {\n    edges {\n      node {\n        id\n        ...PackageDateRow_packageDate\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n  ...PackageDateRow_package\n  ...PackageEditDatesAdd_package\n}\n\nfragment PackageEditDates_package on Package {\n  ...PackageEditDatesAdd_package\n  ...PackageEditDatesList_package_3ASum4\n}\n\nfragment PackageEditMain_package on Package {\n  id\n  name\n  status\n  subtitle\n  markupType\n  markupValueAdult\n  markupValueChild\n  validBeforeTripStartDays\n  remainingPaymentDeadlineDays\n  individualAdvance\n  alreadyPurchased\n  descriptionTitle\n  descriptionText\n  notesTitle\n  notesText\n  organiser\n  city {\n    id\n    name\n  }\n  categories {\n    id\n    name\n  }\n  labels {\n    id\n    name\n  }\n  whatToSee {\n    id\n    name\n  }\n  included {\n    id\n    name\n    icon\n  }\n  excluded {\n    id\n    name\n    icon\n  }\n  documents {\n    id\n    name\n  }\n}\n\nfragment PackageEditTabs_package on Package {\n  allDates: tripDates(first: 2147483647) {\n    pageInfo {\n      total\n    }\n  }\n  media(first: 2147483647) {\n    pageInfo {\n      total\n    }\n  }\n  ...MediaEditor_mediable\n  ...PackageEditMain_package\n  ...PackageEditTransport_package\n  ...PackageEditAccommodation_package\n  ...PackageEditDates_package\n  ...SeoTab_seoable\n  ...EntityHistory_entity\n}\n\nfragment PackageEditTransportFlightsRowActions_package on Package {\n  ...PackageDateAddFlightDialog_package\n}\n\nfragment PackageEditTransportFlightsRowActions_packageDate on PackageDate {\n  id\n  flight {\n    id\n  }\n  ...PackageDateAddFlightDialog_packageDate\n  ...CopyFlightButton_packageDate\n}\n\nfragment PackageEditTransportFlightsRow_package on Package {\n  ...PackageEditTransportFlightsRowActions_package\n}\n\nfragment PackageEditTransportFlightsRow_packageDate on PackageDate {\n  id\n  start\n  end\n  flight {\n    id\n    forwardFlightNumber\n    returnFlightNumber\n    forwardChangeDuration\n    returnChangeDuration\n    priceLive\n    forwardSegments {\n      ...FlightSegments_segments\n      id\n    }\n    returnSegments {\n      ...FlightSegments_segments\n      id\n    }\n  }\n  ...PackageEditTransportFlightsRowActions_packageDate\n}\n\nfragment PackageEditTransportFlights_package on Package {\n  dates: tripDates(first: 2147483647) {\n    edges {\n      node {\n        id\n        ...PackageEditTransportFlightsRow_packageDate\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n  ...PackageEditTransportFlightsRow_package\n}\n\nfragment PackageEditTransport_package on Package {\n  id\n  transportType\n  externalFlights\n  transportName\n  transferPrice\n  services {\n    id\n    name\n  }\n  defaultDepartureAirport {\n    id\n    name\n    code\n  }\n  defaultArrivalAirport {\n    id\n    name\n    code\n  }\n  ...PackageEditTransportFlights_package\n}\n\nfragment PackageSidebar_package on Package {\n  link\n  ...EntitySidebar_entity\n  ...PackageStatus_package\n  ...PackageAutoHotelPriceUpdateSwitch_package\n}\n\nfragment PackageStatus_package on Package {\n  status\n}\n\nfragment RoomNameWithCapacity_room on Room {\n  nameString\n  capacity\n}\n\nfragment RoomRatesEditorCateringSettings_package on Package {\n  id\n  cateringOptions {\n    id\n  }\n}\n\nfragment RoomRatesEditorInit_package on Package {\n  cateringOptions {\n    id\n  }\n  rooms {\n    id\n  }\n  ...RoomRatesEditorRoomSettings_package\n  ...RoomRatesEditorCateringSettings_package\n}\n\nfragment RoomRatesEditorRoomSettings_package on Package {\n  id\n  hotel {\n    id\n    rooms(first: 2147483647) {\n      edges {\n        node {\n          id\n          nameString\n          ...RoomNameWithCapacity_room\n        }\n      }\n    }\n  }\n  rooms {\n    id\n  }\n}\n\nfragment RoomRatesEditorSettingsMenuCatering_package on Package {\n  ...RoomRatesEditorCateringSettings_package\n}\n\nfragment RoomRatesEditorSettingsMenuRooms_package on Package {\n  ...RoomRatesEditorRoomSettings_package\n}\n\nfragment RoomRatesEditorSettingsMenu_package on Package {\n  ...RoomRatesEditorSettingsMenuRooms_package\n  ...RoomRatesEditorSettingsMenuCatering_package\n}\n\nfragment RoomRatesTableDateRow_groupedRate on GroupedRate {\n  date {\n    id\n    start\n    end\n    ...RoomRatesTableRateCell_packageDate\n  }\n  ratesByCatering {\n    cateringOption {\n      id\n      ...CateringOptionName_cateringOption\n      ...RoomRatesTableRateCell_cateringOption\n    }\n    ratesByRoom {\n      ...RoomRatesTableRateCell_rateByRoom\n    }\n  }\n}\n\nfragment RoomRatesTableDateRow_package on Package {\n  ...RoomRatesTableRateCell_package\n}\n\nfragment RoomRatesTableHead_package on Package {\n  rooms {\n    id\n    ...RoomNameWithCapacity_room\n  }\n}\n\nfragment RoomRatesTableRateCellValue_roomRate on RoomRate {\n  roomPriceAdult\n  tripPriceAdult\n}\n\nfragment RoomRatesTableRateCell_cateringOption on CateringOption {\n  id\n  ...RoomRatesTableRateEditor_cateringOption\n}\n\nfragment RoomRatesTableRateCell_package on Package {\n  ...RoomRatesTableRateEditor_package\n}\n\nfragment RoomRatesTableRateCell_packageDate on PackageDate {\n  id\n  ...RoomRatesTableRateEditor_packageDate\n}\n\nfragment RoomRatesTableRateCell_rateByRoom on RateByRoom {\n  room {\n    id\n  }\n  roomRate {\n    ...RoomRatesTableRateCellValue_roomRate\n    id\n  }\n  ...RoomRatesTableRateEditor_rateByRoom\n}\n\nfragment RoomRatesTableRateEditorForm_cateringOption on CateringOption {\n  id\n  ...CateringOptionName_cateringOption\n}\n\nfragment RoomRatesTableRateEditorForm_package on Package {\n  transferPrice\n}\n\nfragment RoomRatesTableRateEditorForm_packageDate on PackageDate {\n  id\n  start\n  end\n  flight {\n    priceLive\n    id\n  }\n}\n\nfragment RoomRatesTableRateEditorForm_rateByRoom on RateByRoom {\n  room {\n    ...RoomNameWithCapacity_room\n    id\n  }\n  roomRate {\n    ...RoomRatesTableRateEditorPriceBreakdown_roomRate\n    id\n  }\n}\n\nfragment RoomRatesTableRateEditorPriceBreakdown_roomRate on RoomRate {\n  tripPriceAdult\n  tripPriceChild\n  baseCostAdult\n  baseCostChild\n  isPercentMarkup\n  markupPercentAdult\n  markupPercentChild\n  markupAmountAdult\n  markupAmountChild\n}\n\nfragment RoomRatesTableRateEditor_cateringOption on CateringOption {\n  id\n  ...RoomRatesTableRateEditorForm_cateringOption\n}\n\nfragment RoomRatesTableRateEditor_package on Package {\n  ...RoomRatesTableRateEditorForm_package\n}\n\nfragment RoomRatesTableRateEditor_packageDate on PackageDate {\n  id\n  ...RoomRatesTableRateEditorForm_packageDate\n}\n\nfragment RoomRatesTableRateEditor_rateByRoom on RateByRoom {\n  room {\n    id\n  }\n  roomRate {\n    id\n    priceNett\n    roomPriceAdult\n    roomPriceChild\n  }\n  ...RoomRatesTableRateEditorForm_rateByRoom\n}\n\nfragment RoomRatesTable_package on Package {\n  groupedRates {\n    date {\n      id\n    }\n    ...RoomRatesTableDateRow_groupedRate\n  }\n  ...RoomRatesTableHead_package\n  ...RoomRatesTableDateRow_package\n}\n\nfragment RoomRatesToolbar_package on Package {\n  ...RoomRatesEditorSettingsMenu_package\n}\n\nfragment SeoTab_seoable on Seoable {\n  __isSeoable: __typename\n  id\n  seo {\n    id\n    slug\n    metaTitle\n    metaDescription\n  }\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "b98cb131d60a31f4f63f845604aa5b07";

export default node;
